import React from 'react';
import styles from './Checkout.module.css';

const CheckoutButton = ({ onClick }) => {
  return (
    <button className={styles.checkoutButton} onClick={onClick}> 
      Invest $
    </button>
  );
};

export default CheckoutButton;
